var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationStep = function SvgLocationStep(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.345,
    d: "M54.36 39.447q-1.392-4.507-3.792-8.874a53 53 0 0 0-1.177-2.037l-.094-.154q-2.702-4.428-5.727-7.926c-3.234-3.745-6.743-6.716-10.535-8.901-2.844-1.64-5.533-2.67-8.06-3.072-2.952-.464-5.681-.095-8.202 1.115-4.686 2.253-7.025 7.55-7.025 15.906 0 5.567 1.93 12.733 5.781 21.5 3.859 8.773 9.694 19.22 17.506 31.361 2.743-1.096 5.237-2.259 7.49-3.51q3.155-1.725 5.666-3.663 2.48-1.885 4.343-3.973 5.789-6.474 5.788-14.824a43.4 43.4 0 0 0-1.963-12.948m-9.681 8.894L35.946 43.3v10.024l-.665-.383-5.157-2.978V39.938l-1.727-.995-7.006-4.047v-6.682l3.86 2.232 4.873 2.81V23.239l4.713 2.723 1.109.638v10.017l.383.222 5.822 3.361 1.419.82 1.109.639z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.345,
    d: "M44.679 41.66v6.682L35.946 43.3l6.205-3.099 1.418.82z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.345,
    d: "m42.15 40.2-6.204 3.1v10.023l-.666-.383-5.156-2.978V39.938l6.205-3.099z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.345,
    d: "m36.33 36.84-6.206 3.1-1.727-.996-7.005-4.047v-6.682l3.858 2.232 4.874 2.81 5.822-2.911v6.272z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.345,
    d: "M35.946 26.601v3.745l-5.822 2.91V23.24l4.713 2.722z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.345,
    d: "M69.768 45.673q0 8.349-5.788 14.823c-2.89 3.234-6.89 6.131-12.013 8.693l-11.442 5.667q3.156-1.726 5.667-3.664 2.48-1.885 4.343-3.973 5.788-6.474 5.788-14.823a43.4 43.4 0 0 0-1.963-12.948q-1.392-4.508-3.792-8.874a53 53 0 0 0-1.176-2.037c-.034-.054-.06-.101-.094-.155q-2.703-4.427-5.728-7.926c-3.233-3.744-6.743-6.716-10.534-8.9-2.844-1.641-5.533-2.67-8.06-3.073-2.952-.464-5.682-.094-8.203 1.116L30.22 2.876Q37.236-.502 46.48 4.833c6.165 3.556 11.583 9.17 16.262 16.826 4.686 7.658 7.025 15.658 7.025 24.014"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m52.134 69.109-.168.08z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#171717",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.345,
    d: "m52.134 69.109-.168.08"
  })));
};
export default SvgLocationStep;